<template>
    <v-container v-if="getLanguageList" class="pa-2" fluid grid-list-sm > 
        <v-layout row wrap>
            <v-flex xs8>
                
            </v-flex>
            <v-flex xs4>
                <CountDown />
            </v-flex>
        </v-layout>       
        <div v-if="needInit">{{initData()}}</div>  

        <v-layout row wrap>
            <v-flex xs6> <v-card outlined >  
                <language-list v-bind:ltype="1"></language-list>
                <q-type56 v-bind:ltype="1"></q-type56>
            </v-card>  </v-flex>
            <v-flex xs6> <v-card outlined >   
                <language-list v-bind:ltype="2"></language-list>
                <q-type56 v-bind:ltype="2"></q-type56>
            </v-card>  </v-flex>
            <v-flex xs12>
                <v-card outlined >
                    <p></p>
                    <p v-if="getRefresh1 || getRefresh2">Preparing...</p>
                    <p v-if="getPreparedforSave && runSaving">{{saveData()}}</p>                    
                    <v-layout align-end justify-space-between row fill-height>
                            <v-flex xs2>
                                <v-menu
                                    transition="slide-y-transition"
                                    bottom
                                    right
                                    >
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            large
                                            class="my-3"
                                            color="primary"
                                            v-on="on"
                                        >
                                        {{ questions_list[task_type_id-5]}}
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item
                                        v-for="(item, index) in questions_list"
                                        :key="index"
                                        @click="changeType(index)"
                                        >
                                        <v-list-item-title>{{ item }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list>  
                                </v-menu>
                            </v-flex>
                            <v-flex xs2>
                                <div v-if="task_type_id == 5">
                                    <v-checkbox
                                        label = "ignore spaces"
                                        v-model="settings.ignoreSpaces"
                                    ></v-checkbox>
                                    <v-checkbox
                                        label = "apostrophe and quotes are the same"
                                        v-model="settings.aqSome"
                                    ></v-checkbox>
                                </div>
                            </v-flex>
                            <v-flex xs1>
                                <v-text-field
                                    v-model="max_score"
                                    label="Score:"
                                    ></v-text-field>                              
                            </v-flex>
                            <v-flex xs4>
                                <v-card outlined>
                                    <v-btn v-if="showSaveButton && (getCountdown > 0 || getCountdown == -100)" @click="saveAndClose">Save and close</v-btn>
                                    <v-btn @click="closeForm">Close without saving</v-btn>                    
                                </v-card>
                            </v-flex>
                    </v-layout>
                    <p></p>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import QType56 from '../../../elements/QType56'
import LanguageList from '../../../elements/LanguageList.vue'
import {mapGetters} from 'vuex'
import axios from '../../../../axios-auth.js'
// import { stringify } from 'querystring';
import CountDown from '../../../elements/CountDown'

export default {
    data() {
        return {    
             runSaving: false,
             closeAfterSaving: false,
             content56: null,
             max_score: 10,
             task_type_id: 5,
             needInit : true,
             ID: 0,
             order: 0,
             lessonID: 0,
             showSaveButton: true, 
             settings: {
                 ignoreSpaces : true,
                 aqSome : false
             },
             questions_list: [
                            'Type 5 (insert source code)',
                            'Type 6 (drag&drop source code)',
                            ]
        }
    },
    computed: 
        mapGetters([
                        'getRefresh1',
                        'getRefresh2',
                        'getAllContent567',
                        'getLanguagePrimary',
                        'getLanguageSecondary',
                        'getPreparedforSave',
                        'getLanguageList',
                        'getAxiosConfig',
                        'getCountdown'
                    ])
    ,
    components: {
        QType56 : QType56,
        LanguageList,
        CountDown
    },
    beforeDestroy() {
        const data = { task_id: this.ID}
        axios.post('/unlock', data, this.getAxiosConfig)
        .then(() => {                
        })
        .catch(() => {
        })
    },    
    methods : {
        prepareDataforSave() {

            //// xxxxx check data - are there some data to fill?

            this.runSaving = true
            // saved data with temporary lang - set it to main lang
            this.$store.commit('setLangPrimaryTmp',this.getLanguagePrimary)
            this.$store.commit('setLangSecondaryTmp',this.getLanguageSecondary)

            this.$store.commit('setPreparedforSave',false)
            // send notification for save to store
            this.$store.commit('setRefresh1',true)
            this.$store.commit('setRefresh2',true)
        },
        saveData() {
            this.runSaving = false
            // prepare data for json
            const data = this.getAllContent567
            var _globals = ''
            if (this.task_type_id == 5) {
                _globals =  JSON.stringify (this.settings)
            }            
            this.content56 = {
                lesson_id: this.lessonID,
                task_id : this.ID,
                task_order : this.order,
                task_type_id : this.task_type_id,
                globals: _globals,
                max_score : this.max_score,
                content_list: []
            }
            
            for(var key in data) {
                this.content56.content_list.push( {
                    lang_id : key.replace('l',''),
                    content : JSON.stringify (data[key])
                })
            }

            // axios
            axios.post('/create-edit-task-all-lang', this.content56, this.getAxiosConfig)
            .then(() => {    
                if (this.closeAfterSaving) this.closeForm()
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
        
        },
        changeType(index) {
            this.task_type_id = 5 + index
                if (this.task_type_id == 5) {
                    this.$store.commit('setFakes', false)
                } else {
                    this.$store.commit('setFakes', true)
                }
        },

        saveAndClose() {
            this.closeAfterSaving = true
            this.prepareDataforSave()            
        },
        closeForm() {
            this.$router.push({name:'lesson_admin_content', params: {id: this.lessonID}})
        },
        initData() {
            this.needInit = false
            this.$store.commit('setBcChange',true)
            this.$store.commit('setCountdown', this.$route.params.id)

            this.$store.commit('setFeedback', null)
            // saved data with temporary lang - set it to main lang
            this.$store.commit('setLangPrimaryTmp',this.getLanguagePrimary)
            this.$store.commit('setLangSecondaryTmp',this.getLanguageSecondary)
            this.$store.commit('setFakes', false)
            this.$store.commit('setCollapses')    

            this.ID = this.$route.params.id

            if (this.ID == '0') {
                this.$store.commit('prepare56')
                this.task_type_id = localStorage.getItem('qtype')
                if (this.task_type_id == 6) {
                    this.$store.commit('setFakes', true)
                }
                this.lessonID = JSON.parse(localStorage.getItem('position')).activeLesson.id
            } else {
            // load existing data
                axios.get('/get-task-in-all-lang/' + this.ID, this.$store.getters.getAxiosConfig )
                .then(res => {
                    if (res.data.islocked) {
                        this.showSaveButton = false
                        this.$store.commit('setFeedback', 'The content is locked by another user, you can only read or wait 30 minutes.')    
                    }

                    this.max_score = res.data.max_score
                    this.task_type_id = res.data.task_type
                    this.lessonID = res.data.lesson_id
                    this.order = res.data.task_order

                    if (this.task_type_id == 6) {
                        this.$store.commit('setFakes', true)
                    }

                    const data = {                        
                        content_list : res.data.list
                    }

                    // read settings
                    if (this.task_type_id == 5) {
                        if (res.data.globals != null && res.data.globals != '') {
                            var set = JSON.parse(res.data.globals)
                            if (set == null || set.ignoreSpaces == null ) {
                                this.settings = {
                                    ignoreSpaces : true,
                                    aqSome : false
                                }
                            } else {
                                this.settings = set
                            }
                        }
                    }

                    this.$store.dispatch('setFullContent56', data)
                    this.$store.dispatch('setActiveMicro', {id:this.$route.params.id, name: ''})
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
            } 
        }
    },
    mounted() {
        this.needInit = true
    }      
     
}
</script>


